import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

//Axios.defaults.withCredentials = true; // mělo by odesílat cookies - session_id


Vue.config.productionTip = false;

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// moment js
Vue.use(require('vue-moment'));

// event hub
Vue.prototype.$eventHub = new Vue();

// authentifikace
Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token

  // dolar který je v http je akorát konvence kterou se označuje proměnná, která má globální scope
  // a je vidět ve všech componentách
}
// authentifikace END

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
